import React, { useState } from "react";
import {
  subscribeInput, subscribeInputMail,
  emailInput, subscribeInputText,
  subscribeInputForm, successMsg, box,
  emailSubmit, text, whiteIcon, subtitle, newSubscribeInputForm,
  newSubscribeInput, newSubscribeInputMail, buttonTitle, belowButtonText,
  coloredText, newSubtitle, newSubscribeInputText, subheadline
} from "./style.mod.scss";
import locale from "locales";
import ArrowRight from "assets/svgs/arrow-right.svg";
import TickIcon from "assets/svgs/tick.svg";
import { Formik, Field, Form } from "formik";
import { loadRecaptcha } from "helpers/load-recaptcha";
import Link from "components/link";
import { trackSignUp, trackEmailAddress } from "helpers/analytics";
import hashEmailAddress from "helpers/hash-email-address";

const activeSubscribeForm =  ({ data }) => {
  const id = data?.id;
  const [submitted, setSubmitted] = useState(false);
  const handleSubscribe = async ({ email }) => {
    window.grecaptcha.ready(async function () {
      await window.grecaptcha.execute(process.env.GATSBY_RECAPTCHA_SITE_KEY, { action: "submit" });

      const response = await fetch("/.netlify/functions/klaviyo",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            listId: id
          })
        }
      );

      if (response?.status === 204) {
        setSubmitted(locale.account.waitingList.joinedWaitingList);
      }
    });
    trackSignUp("newsletter", "email address");
    const hashedEmail = await hashEmailAddress(email);
    trackEmailAddress(hashedEmail);
  };


  return (
    <div className={data?.image ? `${subscribeInput} ${newSubscribeInput}` : subscribeInput} id="activeSubscribeForm" style={{ backgroundColor: data.bgColor && data.bgColor.hex }}>
      <Formik
        initialValues={{ email: "" }}
        onSubmit={handleSubscribe}
      >
        {({ isSubmitting, handleChange }) => (
          <Form className={data?.image ? `${subscribeInputForm} ${newSubscribeInputForm}` : subscribeInputForm}>
            {!submitted &&
              <>
                <div className={data?.image ? newSubscribeInputText : subscribeInputText}>
                  <p style={{ color: data?.textColor && data?.textColor?.hex }} className={subheadline}>{data?.subheadline}</p>
                  <h2 style={{ color: data?.textColor && data?.textColor?.hex }}>{data.text}</h2>
                  <p style={{ color: data?.textColor && data?.textColor?.hex }} className={data?.image ? newSubtitle : subtitle} dangerouslySetInnerHTML={{ __html:data?.description }}/>
                </div>
                <div className={data?.image ? `${subscribeInputMail} ${newSubscribeInputMail}` : subscribeInputMail}>
                  <Field className={emailInput} onChange={handleChange} onFocus={loadRecaptcha} name="email" placeholder={data?.image ? locale.footer.yourEmailAddress : locale.footer.yourEmail} />
                  <button className={data?.image ? `${whiteIcon} ${emailSubmit} ${buttonTitle}` : data?.btnColor?.hex == "#18404b" ? `${whiteIcon} ${emailSubmit}` : `${emailSubmit}`}
                    type="submit" style={{ backgroundColor: data?.btnColor && data?.btnColor?.hex }} disabled={isSubmitting} id="submitForm">{data?.image ? data?.buttonText : <ArrowRight />}
                  </button>
                </div>
                {data?.image &&
                  <div className={belowButtonText}>
                    <span>{locale.newsletter.text} <Link to={locale?.newsletter?.privacyAndPolicyUrl} target="_blank"><span className={coloredText}>{locale.newsletter.privacyPolicy}</span></Link></span>
                  </div>}
              </>
            }
            {submitted && <div className={successMsg}>
              <div className={box}>
                <TickIcon />
                <div className={text}>
                  <p style={{ fontWeight: "bold" }}>{data?.sucessSubmissionTitle ? data?.sucessSubmissionTitle : locale.footer.thankYouTitle}</p>
                  <p>{data?.successSubmissionDescription ? data?.successSubmissionDescription : locale.footer.thankYouBody}</p>
                </div>
              </div>
            </div>}
          </Form>
        )}
      </Formik>
    </div>
  );
};


export default activeSubscribeForm;
